import QuizLogoHeader from '@/features/quiz/quiz-logo-header'
import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { QuestionSelectionError } from '@/lib/apis/types'

type Props = {
  error?: QuestionSelectionError
}

export default function QuizErrorRenderer({ error }: Props) {
  if (!error) return null
  if (error.type !== 'generic-error') return null

  switch (error.cls) {
    case 'OnlyForMen':
      return (
        <div>
          <QuizLogoHeader />
          <div className="mx-auto mt-16 flex max-w-3xl flex-col gap-y-12">
            <div className="space-y-0.5 leading-normal tracking-tight">
              <p className="font-display text-2xl font-medium text-blue-800">
                Unable to Proceed with Treatment Plan
              </p>
              <p className="text-xl text-blue-600">
                This treatment plan is designed specifically for men
              </p>
            </div>
            <div className="space-y-2 text-pretty text-lg tracking-tight text-gray-600">
              <p>
                We{"'"}re sorry, but the erectile dysfunction (ED) treatment
                plan you{"'"}re trying to access is specifically designed for
                individuals assigned male at birth. This treatment addresses
                physiological conditions unique to male anatomy. If you believe
                you{"'"}ve reached this message in error, please contact our
                support team for assistance at{' '}
                <span className="text-blue-700">support@nextclinic.com.au</span>
                .
              </p>
            </div>
            <Link
              href="/"
              className="flex items-center gap-x-2 font-medium text-gray-800"
            >
              Go back home <FontAwesomeIcon icon={faArrowRight} />
            </Link>
          </div>
        </div>
      )
  }
}
